import { z } from 'zod';
import { TimestampSchema } from './common';

/**
 * RESERVED schemas — not built in V1, kept here so the data model "leaves
 * room" for them (PRD §20) without designing them out. Do not surface these
 * in the V1 UI. (MoveProfile graduated to ./moveProfile.ts in V1.5.)
 */

/** leads/{leadId} top-level (PRD §15.12) — mover-lead monetization layer. */
export const LeadSchema = z.object({
  id: z.string(),
  userId: z.string(),
  name: z.string(),
  phone: z.string().optional(),
  email: z.string().email().optional(),
  inventoryCount: z.number().int().optional(),
  consentContact: z.boolean().optional(),
  createdAt: TimestampSchema,
});
export type Lead = z.infer<typeof LeadSchema>;
